<template>
  <div class="profile-pic" :class="[ miniView ? 'miniview' : '']">
    <figure class="image" :class="[miniView ? 'twitter-image-tiny' : (large ? 'twitter-image-large' : 'twitter-image-normal')]">
      <div v-if="!user">
        <profile-img :user="user" :large="large" :rounded="rounded" />
      </div>
      <div v-else-if="large">
        <a @click="showModal = true"><profile-img :user="user" :large="large" :rounded="rounded" /></a>
      </div>
      <div v-else-if="noClick">
        <profile-img :user="user" :rounded="rounded" />
      </div>
      <div v-else>
        <link-to-profile :screen-name="user.screen_name"><profile-img :user="user" :large="large" :rounded="rounded" /></link-to-profile>
      </div>
    </figure>
    <b-modal v-if="user" v-model="showModal" :destroy-on-hide="false" class="modal-image">
      <p class="image">
        <img :src="user.image_url_orig" :alt="user.name">
      </p>
    </b-modal>
  </div>
</template>
<script>
import LinkToProfile from "./controls/LinkToProfile";
import ProfileImg from "./ProfileImg";
export default {
  name: 'ProfilePic',
  components: {ProfileImg, LinkToProfile},
  props: {
    user: Object,
    large: {
      type: Boolean,
      default: false,
    },
    miniView: {
      type: Boolean,
      default: false
    },
    noClick: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showModal: false
    }
  }
}
</script>

<style lang="scss" scoped>

.profile-pic > figure {
  width: 36px;
  height: auto;
  margin: 0;
  &.twitter-image-tiny {
    width: 1.5em;
    margin-right: 0.25em;
  }

  &.twitter-image-large {
    width: 72px;
  }
}

.miniview {
  display: inline-block;

  img {
    width: 1.2rem;
    height: 1.2rem;
    margin-right: 0.5rem;
    margin-bottom: -0.25rem;
  }
}

</style>
